export enum Scheme {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  fail = 'fail'
}
